import { render, staticRenderFns } from "./OutboundSettings.vue?vue&type=template&id=408d204c&scoped=true&"
import script from "./OutboundSettings.vue?vue&type=script&lang=js&"
export * from "./OutboundSettings.vue?vue&type=script&lang=js&"
import style0 from "./OutboundSettings.vue?vue&type=style&index=0&id=408d204c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408d204c",
  null
  
)

/* custom blocks */
import block0 from "./OutboundSettings.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports